import { WarningCircle } from "@phosphor-icons/react";

const NameInput = ({ value, onChange, error }) => {
    return (
        <div className="input-group pb-8 border-b-[1.5px] h-[112px] ">
            <label className="block text-sm">Name</label>
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder="Enter hotel name"
                className="mt-1 block w-[95%] p-2 border-[1.5px] border-gray-300 rounded-lg"
            />
            {error && (
                <span className="text-[#E47186] text-xs flex items-center gap-1">
                    <WarningCircle className="text-sm" />
                    {error}
                </span>
            )}
        </div>
    );
};

export default NameInput;
